const common = require("./src/common")
const cv = require("./src/cv")
const user = require("./src/user")
const job = require("./src/job")
const style = require("./src/style")


module.exports = {
    regex: common.regex,
    urls: common.urls,
    supportedWebPlatforms: common.supportedWebPlatforms,
    fbConfigDef: common.fbConfigDef,
    iapConfig: common.iapConfig,

    maxCvLength: cv.maxCvLength,
    defaultCvObject: cv.defaultCvObject,
    defaultModelLayout: cv.defaultModelLayout,
    modelCatalogue: cv.modelCatalogue,
    fontCatalogue: cv.fontCatalogue,
    colorCatalogue: cv.colorCatalogue,
    basePatternCatalogue: cv.basePatternCatalogue,
    baseImageCatalogue: cv.baseImageCatalogue,
    abilityFormatCatalogue: cv.abilityFormatCatalogue,
    cvPickerItems: cv.cvPickerItems,
    prewrittenPhraseCategoryCatalogue: cv.prewrittenPhraseCategoryCatalogue,
    sectionGroupedCatalogue: cv.sectionGroupedCatalogue,
    countriesWithoutPhoto: cv.countriesWithoutPhoto,

    onboardingSeniorityCatalogue: user.onboardingSeniorityCatalogue,
    onboardingGoalCatalogue: user.onboardingGoalCatalogue,
    onboardingTimeCatalogue: user.onboardingTimeCatalogue,
    onboardingPersonalityCatalogue: user.onboardingPersonalityCatalogue,
    onboardingColorCatalogue: user.onboardingColorCatalogue,

    jobTrackerStatusCatalogue: job.jobTrackerStatusCatalogue,
    jobTrackerInterviewTypeCatalogue: job.jobTrackerInterviewTypeCatalogue,
    colors: style.colors,
    margin: style.margin,
    padding: style.padding,
    typography: style.typography,
    layout: style.layout
}